import { autoinject } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { Location } from "../../models/location";
import { LeafletMap } from "../../mapping/leaflet-map"
import * as Linq from "linq-es2015";
import * as L from 'leaflet';
import { MdTabs } from "aurelia-materialize-bridge";
import { Api } from "../../services/api";
import { IState } from "../../store/state";
import { Store } from 'aurelia-store';
import { GpsMap } from "../../models/gps-map";
import { AssetLocationMeasurement } from "../../models/asset-location-measurement";
import { HubEvents } from "../../events/hub-events";

@autoinject
export class AssetTracking {
	locations: Array<Location>;
	selectedLocation: Location;
	maps : Map<string, LeafletMap> = new Map<string, LeafletMap>();
	//map: LeafletMap;
	mapHeight: number = 600;
	//mapId: string = "signal-map";
	eventAggregator: EventAggregator;
	subscription: any;
	gpsMappingSubscription: Subscription;
	hasMeasurement: boolean = false;
	icon: string;
	color: string;
	assetLocationMeasurement: AssetLocationMeasurement = new AssetLocationMeasurement();
	tabs: MdTabs;
	api: Api;
	//gpsMaps: Array<GpsMap>;
	gpsMapMessage: string;
	protected applicationState: IState;
	protected store: Store<IState>;
	private markers: Map<string, L.Marker> = new Map<string, L.Marker>();


	constructor(store: Store<IState>, eventAggregator: EventAggregator, api: Api) {
		this.store = store;
		this.eventAggregator = eventAggregator;
		this.api = api;
	}

	async bind(bindingContext: any, overrideContext: any) {

		this.subscription = this.store.state.subscribe(async (state) => {
			this.applicationState = state;
			if (this.applicationState.locationState.initialized) {
				this.locations = this.applicationState.locationState.selectedLocations;
				
				if (!this.selectedLocation && this.locations && this.locations.length > 0) {
					this.selectedLocation = this.getCurrentLocation();
					this.tabs.refresh();
				}
			}
		});

		this.locations.forEach(async location => {
			const response = await this.api.getGpsMapping(location.id);
			const map = this.maps.get(location.id);
			if (response.success) {
				//this.gpsMaps = response.data;
				this.renderPins(response.data, map);
			}
		});
		
	}
	attached() {

		this.gpsMappingSubscription = this.eventAggregator.subscribe(HubEvents.assetLocationMeasurementEvent,
			(assetLocationMeasurement: AssetLocationMeasurement) => {

				if (assetLocationMeasurement.data.latitude !== undefined && assetLocationMeasurement.data.longitude !== undefined) {

					this.assetLocationMeasurement = assetLocationMeasurement;
					this.hasMeasurement = true;
					if (assetLocationMeasurement.data.gpsFixed === true) {
						var map = this.maps.get(assetLocationMeasurement.locationId);
						this.color = "green-text";
						this.icon = "mdi-wifi";
						this.gpsMapMessage = `New GPS measurement added at ${assetLocationMeasurement.data.timestamp}`;
						this.addPin(assetLocationMeasurement, map);
					
					} else {
						this.color = "red-text";
						this.icon = "mdi-wifi-off";
						this.gpsMapMessage = `The last GPS measurement was not fixed!: ${assetLocationMeasurement.data.timestamp}`;
					}
				}
			});

		this.configureMaps();

		// wait 100 ms to allow the MdTabs attached method to fire and thus create an instance of the underlying tab control
		// otherwise the call to tabs.select will fail.
		setTimeout(() => {
			if (this.selectedLocation) {
				if (this.locations && this.locations.length > 0 &&
					this.selectedLocation &&
					this.selectedLocation.id !== this.locations[0].id) {
					this.tabs.select(this.selectedLocation.id);
				}
			}
		}, 100);
	}


	getCurrentLocation(): Location {
		const currentLocationId = localStorage.getItem("current-location");
		if (!currentLocationId) {
			return this.locations[0];
		}

		const currentLocations = this.locations.filter(l => l.id === currentLocationId);
		return currentLocations[0];
	}

	configureMaps() {
		this.locations.forEach(location => this.configureMap(location));
	}

	configureMap(location: Location) {
		const mapConfig = {
			location: JSON.parse(location.gpsCoordinates),
			zoom: 17,
			minZoom: 12
		};


		var container = L.DomUtil.get(location.id);
		if (container != null) {
			container._leaflet_id = null;
		}

		//if (this.map !== undefined) {
		//	this.map.imap.off();
		//	this.map.imap.remove();
		//}

		const map = new LeafletMap(location.id, mapConfig, "Satellite");
		map.showZoomControl();
		map.addLayerGroup("Devices");
		map.showLayerControl();
		map.invalidateSize();

		this.maps.set(location.id, map);
	}

	unbind() {
		this.subscription.unsubscribe();
		this.gpsMappingSubscription.dispose();
	}

	clearPins() {
		// TODO...
		
		//this.map.removeMarkers("Devices");
	}


	greenIcon = new L.Icon({
		iconUrl: `${window.location.origin}/images/markers/marker-icon-green.png`,
		shadowUrl: `${window.location.origin}/images/markers/marker-shadow.png`,
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],
		shadowSize: [41, 41]
	});

	yellowIcon = new L.Icon({
		iconUrl: `${window.location.origin}/images/markers/marker-icon-yellow.png`,
		shadowUrl: `${window.location.origin}/images/markers/marker-shadow.png`,
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],
		shadowSize: [41, 41]
	});

	redIcon = new L.Icon({
		iconUrl: `${window.location.origin}/images/markers/marker-icon-red.png`,
		shadowUrl: `${window.location.origin}/images/markers/marker-shadow.png`,
		iconSize: [25, 41],
		iconAnchor: [12, 41],
		popupAnchor: [1, -34],
		shadowSize: [41, 41]
	});

	determinePinColor(rssi: number): L.Icon {

		switch (true) {
			case (rssi < -110):
				return this.redIcon;
			case (rssi < -100):
				return this.yellowIcon;
			default:
				return this.greenIcon;
		}

	}
	
	renderPins(assetLocationMeasurements: Array<AssetLocationMeasurement>,map: LeafletMap) {
		for (let assetLocationMeasurement of assetLocationMeasurements) {
			this.addPin(assetLocationMeasurement, map);
		}
	}

	addPin(assetLocationMeasurement: AssetLocationMeasurement, map:LeafletMap) {
		if (assetLocationMeasurement.data) {
			const data = assetLocationMeasurement.data;
			let icon = this.determinePinColor(data.rssi);
			const marker = map.addMarker({ "lat": data.latitude, "lng": data.longitude },
				assetLocationMeasurement.deviceId,
				`latitude: ${data.latitude}<br/> longitude:${data.longitude}<br/> RSSI: ${data.rssi}<br/> LSNR: ${assetLocationMeasurement.lsnr}<br/>${data.timestamp}`,
				"Devices",
				icon);

		    // var m = map.markers.
			//this.markers.set(gpsMap.id, marker);
		}
	}

	async onTabSelected($event) {
		const locationId = $event.detail.substring(1);
		localStorage.setItem("current-location", locationId);
		var map = this.maps.get(locationId);
		map.invalidateSize();
		//this.configureMap(this.selectedLocation);
	}


}